import { networkType } from "../config";

const CONTRACT_ADDRESSES = {
  testnet: {
    ThawingPool: "0x0120Cd8F360F4D128E5C624BAC30b7b2A208C67F",
    stSPON: "0x9Be4c94A160FbF26988F0B36cC200B0DC67851D4",
    SPON: "0x76e593392523243ACD38ceD87c2007F14483a86B",
  },
  mainnet: {
    ThawingPool: "0x859e98624786ae9f985d09E5653e8b80B1F62a3d",
    stSPON: "0x662bd61b6cdCC25FcA7a8B32C92B9055c1634E75",
    SPON: "0x080D43c2164AFdBc3712422CE78Ab902ccaB5CA1",
  },
} as const;

export const ThawingPool = CONTRACT_ADDRESSES[networkType].ThawingPool;
export const stSPON = CONTRACT_ADDRESSES[networkType].stSPON;
export const SPON = CONTRACT_ADDRESSES[networkType].SPON;
